import {Component, inject} from '@angular/core';
import {ButtonVariants} from '@jtm/jtm-components';
import {UntilDestroy} from '@jumio/portals.core';
import {Subscription} from 'rxjs';
import {WelcomeRedirectService} from '../../services/redirect/redirect.service';
import {getKyxIconUrl} from 'shared/components/kyx-icon.helper';
import {getAssetsUrl} from 'core/helpers';
import {EnvironmentProvider} from 'public-shared/services/environment-provider';
import {J4WelcomeEnvironmentData} from '../../../environments/environment.prod';

@UntilDestroy()
@Component({
  templateUrl: './error403.component.html',
  styleUrls: ['./error403.component.scss'],
  standalone: false
})
export class Error403Component {
  private environmentProvider = inject<EnvironmentProvider<J4WelcomeEnvironmentData>>(EnvironmentProvider);
  public readonly subscription = new Subscription();
  public btnVariant = ButtonVariants.Secondary;

  constructor(private welcomeRedirectService: WelcomeRedirectService) {}

  public redirectToHomePage(): void {
    this.subscription.add(
      this.welcomeRedirectService.getFirstAvailableRoute$().subscribe({
        next: url => {
          this.welcomeRedirectService.directsToPath(url);
        },
        error: () => {
          this.welcomeRedirectService.directsToLoginPage();
        }
      })
    );
  }

  protected iconUrl(name: string): string {
    const iconPath = getKyxIconUrl(name);
    return getAssetsUrl(iconPath, this.environmentProvider.environment.deployUrl, this.environmentProvider.environment);
  }
}
